import { render, staticRenderFns } from "./confirmList.vue?vue&type=template&id=125b31b8&scoped=true&"
import script from "./confirmList.vue?vue&type=script&lang=js&"
export * from "./confirmList.vue?vue&type=script&lang=js&"
import style0 from "./confirmList.vue?vue&type=style&index=0&id=125b31b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b31b8",
  null
  
)

export default component.exports